import { render, staticRenderFns } from "./PriceMatchOptions.vue?vue&type=template&id=e13f2aae&"
import script from "./PriceMatchOptions.vue?vue&type=script&lang=js&"
export * from "./PriceMatchOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports